(function () {
  'use strict';

  var MARKER_RE = /\[\[amount:(\d+(?:\.\d+)?)(?::([A-Z]{3}))?\]\]/g;
  var config = window.theme && window.theme.currencyThreshold ? window.theme.currencyThreshold : {};
  var BASE_CURRENCY = config.baseCurrency || 'SAR';
  var probeSeq = 0;

  function getActiveCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return config.activeCurrency || BASE_CURRENCY;
  }

  function amountToCents(amount) {
    return Math.round(Number(amount) * 100);
  }

  function stripHtml(html) {
    var el = document.createElement('span');
    el.innerHTML = html;
    return el.textContent || '';
  }

  function formatBaseMoney(cents, baseCurrency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && config.moneyFormat) {
      return stripHtml(window.Shopify.formatMoney(cents, config.moneyFormat));
    }
    return (cents / 100) + ' ' + baseCurrency;
  }

  function createThresholdElement(amount, baseCurrency) {
    var base = baseCurrency || BASE_CURRENCY;
    var cents = amountToCents(amount);
    var span = document.createElement('span');

    span.className = 'money conversion-bear-money currency-threshold';
    span.setAttribute('data-currency', base);
    span.setAttribute('data-currency-' + base, String(cents));
    span.setAttribute('data-currency-amount', String(amount));
    span.setAttribute('data-currency-base', base);
    span.textContent = formatBaseMoney(cents, base);

    return span;
  }

  function refreshConversionBear() {
    [
      function () { if (window.Currency && window.Currency.convertAll) window.Currency.convertAll(); },
      function () { if (window.DoublyGlobalCurrency && window.DoublyGlobalCurrency.convertAll) window.DoublyGlobalCurrency.convertAll(); },
      function () { if (window.bearCurrency && window.bearCurrency.convertAll) window.bearCurrency.convertAll(); },
      function () { if (window.ConversionBear && window.ConversionBear.convert) window.ConversionBear.convert(); },
      function () { document.dispatchEvent(new CustomEvent('currency:changed')); }
    ].forEach(function (fn) {
      try { fn(); } catch (e) { /* ignore */ }
    });
  }

  function processMarkers(root) {
    if (!root || !root.innerHTML || root.innerHTML.indexOf('[[amount:') === -1) return false;

    var updated = root.innerHTML.replace(MARKER_RE, function (_match, amount, baseCurrency) {
      return createThresholdElement(parseFloat(amount), baseCurrency || BASE_CURRENCY).outerHTML;
    });

    if (updated === root.innerHTML) return false;

    root.innerHTML = updated;
    return true;
  }

  function processAll() {
    var changed = false;

    document.querySelectorAll('[data-currency-content], .currency-content').forEach(function (root) {
      if (processMarkers(root)) changed = true;
    });

    if (changed) refreshConversionBear();
  }

  function formatCurrencyThreshold(amount, baseCurrency) {
    var base = baseCurrency || BASE_CURRENCY;
    var active = getActiveCurrency();

    if (active === base) {
      return formatBaseMoney(amountToCents(amount), base);
    }

    var existing = document.querySelector(
      '.currency-threshold[data-currency-amount="' + amount + '"][data-currency-base="' + base + '"]'
    );
    if (existing && existing.textContent) {
      return existing.textContent.trim();
    }

    return formatBaseMoney(amountToCents(amount), base);
  }

  function formatCurrencyThresholdAsync(amount, baseCurrency) {
    var base = baseCurrency || BASE_CURRENCY;
    var active = getActiveCurrency();

    if (active === base) {
      return Promise.resolve(formatBaseMoney(amountToCents(amount), base));
    }

    return new Promise(function (resolve) {
      var probe = createThresholdElement(amount, base);
      var probeId = 'currency-threshold-probe-' + (++probeSeq);

      probe.id = probeId;
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = [
        'position:absolute',
        'width:1px',
        'height:1px',
        'padding:0',
        'margin:-1px',
        'overflow:hidden',
        'clip:rect(0,0,0,0)',
        'white-space:nowrap',
        'border:0'
      ].join(';');

      document.body.appendChild(probe);
      refreshConversionBear();

      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        observer.disconnect();
        clearTimeout(timeoutId);
        var text = probe.textContent ? probe.textContent.trim() : formatBaseMoney(amountToCents(amount), base);
        probe.remove();
        resolve(text);
      }

      var observer = new MutationObserver(finish);
      observer.observe(probe, { childList: true, characterData: true, subtree: true });

      var timeoutId = setTimeout(finish, 600);
    });
  }

  function convertStaticAmount(opts) {
    if (!opts || opts.amount == null) return '';
    return formatCurrencyThreshold(opts.amount, opts.baseCurrency || BASE_CURRENCY);
  }

  function setupCurrencyChangeListeners() {
    var debounceId;

    function scheduleRefresh() {
      clearTimeout(debounceId);
      debounceId = setTimeout(processAll, 120);
    }

    document.addEventListener('click', function (evt) {
      if (evt.target.closest('.ultimate-currency, .currency-selector, [data-currency-switcher]')) {
        scheduleRefresh();
      }
    }, true);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (
          target.classList &&
          (target.classList.contains('conversion-bear-money') || target.classList.contains('currency-threshold'))
        ) {
          scheduleRefresh();
          break;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function init() {
    processAll();
    setupCurrencyChangeListeners();
    refreshConversionBear();
  }

  window.CurrencyThreshold = {
    formatCurrencyThreshold: formatCurrencyThreshold,
    formatCurrencyThresholdAsync: formatCurrencyThresholdAsync,
    convertStaticAmount: convertStaticAmount,
    createElement: createThresholdElement,
    refresh: processAll,
    getActiveCurrency: getActiveCurrency,
    getBaseCurrency: function () { return BASE_CURRENCY; }
  };

  window.formatCurrencyThreshold = formatCurrencyThreshold;
  window.convertStaticAmount = convertStaticAmount;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(processAll, 50);
  });
})();
